import { useQuery } from 'react-query'
import { toast } from 'react-toastify'
import { axios } from '../../../lib'
import { Response } from '../../../services/api/types'

const loadOrderProposal = (id?: string): Response<any> => {
  return axios.get(`/orders/proposals/${id}`)
}

export function useLoadOrderProposal(id?: string) {
  return useQuery(['proposal', id], () => loadOrderProposal(id), {
    enabled: !!id,
    select: (data) => {
      const colecao = data.data.colecao?.trim() || ''
      const mapped = {
        ...data.data,
        cdPedidoReserva: data.data.cdPedidoReserva?.trim() || '',
        crossSale:
          colecao === 'VD CRUZADA' ? { id: 'YES', label: 'Sim' } : null,
        products: data.data.products.map((prod: any) => {
          const parsedOrigin = prod.origin != null ? Number(prod.origin) : 0
          return {
            ...prod,
            origin: parsedOrigin,
            saleType: prod.saleType || (parsedOrigin !== 0 ? '4' : '12')
          }
        })
      }

      return mapped
    },
    onError: () =>
      toast.error('Não foi possível carregar o pedido', {
        toastId: 'order'
      })
  })
}
